import { computed } from 'vue';
import { useAccountStore, useSCIMSettingsStore, useUsersStore } from '@/stores';
import { featureAccessMap } from './featureAccessMap';
import { useGetPaginatedApplicationLinks } from '@/queries/applicationSwitcher/useGetApplicationLinks';
import { ApiApplicationType } from '@eencloud/eewc-components/src/service/api-types';
import { AccessContext, UserManagementType } from '@/types';

export function useFeaturePermissionAccess() {
  const usersStore = useUsersStore();
  const accountStore = useAccountStore();
  const scimSettingsStore = useSCIMSettingsStore();

  const APPLICATION_LINKS_PARAMS = {
    type: ApiApplicationType.AppLauncher,
    sort: '+name',
    pageToken: '',
    pageSize: 50,
  };
  const { data: applicationLinksData, isLoading: isApplicationLinksDataLoading } =
    useGetPaginatedApplicationLinks(APPLICATION_LINKS_PARAMS);

  const permissions = computed<AccessContext>(() => {
    return {
      users: usersStore.currentUser?.permissions,
      account: {
        accountCapabilities: accountStore.accountCapabilities,
        effectiveAccountPermissions: accountStore.account?.effectivePermissions,
      },
      bssUser: !!applicationLinksData.value?.pages[0]?.results?.length && !isApplicationLinksDataLoading.value,
      demoUser: usersStore.currentUser?.id === 'ca0f61ab',
      scimEnabled: scimSettingsStore.settings?.enabled ?? false,
      videoSearchAlertsEnabled: accountStore.accountCapabilities?.videoSearchAlerts ?? false,
      scimManagedUser: usersStore.currentUser?.status?.managedBy === UserManagementType.SCIM,
    };
  });

  function isPermitted(featureKey: keyof typeof featureAccessMap): boolean {
    const rule = featureAccessMap[featureKey];
    return rule ? !!rule(permissions.value) : false;
  }

  return {
    isPermitted,
    isApplicationLinksDataLoading,
  };
}
